package com.example.mystybag.core.logic.helpers

import androidx.compose.foundation.text.KeyboardOptions
import com.arkivanov.decompose.value.MutableValue
import com.arkivanov.decompose.value.update
import com.example.mystybag.core.model.AdditionalIcon
import com.example.mystybag.core.model.ButtonImageVisualModel
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.core.model.UINavigationState

class NavigationBarConfig(private val controls: MutableValue<UINavigationState>) {
    var additionalIcons: List<AdditionalIcon>?
        get()       = controls.value.additionalIcons
        set(value)  = controls.update { it.copy(additionalIcons = value) }

    var backButtonVisible: Boolean
        get()       = controls.value.backButtonVisible
        set(value)  = controls.update { it.copy(backButtonVisible = value) }

    var isVisible: Boolean
        get()       = controls.value.navVisible
        set(value)  = controls.update { it.copy(navVisible = value) }

    var title: String
        get()       = controls.value.title
        set(value)  = controls.update { it.copy(title = value) }

    var leadingIcon    : ImageDescription?
        get()       = controls.value.leadingIcon
        set(value)  = controls.update { it.copy(leadingIcon = value) }

    var keyboardOptions : KeyboardOptions
        get()       = controls.value.keyboardOptions
        set(value)  = controls.update { it.copy(keyboardOptions = value) }

    var smallButtons: List<ButtonImageVisualModel>?
        get ()      = controls.value.smallButtons
        set(value)  = controls.update { it.copy(smallButtons = value) }

    fun updateSmallButton(index: Int, block: (ButtonImageVisualModel) -> ButtonImageVisualModel) {
        smallButtons = smallButtons?.mapIndexed { id, it ->
            if (index == id)
                block(it)
            else
                it
        }
    }
}